import { Box, Fab } from '@mui/material';
import { AddRounded } from '@mui/icons-material';
import React, { Component } from 'react';
import TimeSheetForm from './TimeSheet/TimeSheetForm';
import { MonthView } from '@devexpress/dx-react-scheduler-material-ui';
import Schedule from './TimeSheet/Schedule';
import { isEmpty } from 'lodash';

class EmployeeTimeSheet extends Component {
    state = { 
        openForm: false
    }
    componentDidMount = () => {
        if(isEmpty(this.props.PROJECTS)){
            this.props.fetchProjects()
        }
        if(isEmpty(this.props.TIMESHEETS)){
            this.props.fetchEmployeeTimesheets()
        }
    }
    render() {
        const { openForm } = this.state;
        const { TIMESHEETS } = this.props;
        return (
            <Box p={2}>
                <Box p={2} style={{textAlign: "right"}}>
                    <Fab title="Nouveau"
                        color="secondary"
                        onClick={ () => this.setState({ openForm: true})}
                    >
                        <AddRounded />
                    </Fab>
                </Box>
                    
                {openForm &&
                    <TimeSheetForm
                        {...this.props}
                        handleClose={() => this.setState({ openForm: false})}
                    />
                }
                <Schedule
                    appointments={Object.values(TIMESHEETS)}
                    {...this.props}
                />
            </Box>
        );
    }
}

export default EmployeeTimeSheet;